// costOfSalesContdReducer init state months

export const mediaBuyingMonths = {
  0: 300000,
  1: 300000,
  2: 300000,
  3: 300000,
  4: 300000,
  5: 300000,
  6: 300000,
  7: 300000,
  8: 300000,
  9: 300000,
  10: 300000,
  11: 300000,
  12: 300000,
  13: 300000,
  14: 300000,
  15: 300000,
  16: 300000,
  17: 300000,
  18: 300000,
  19: 300000,
  20: 300000,
  21: 300000,
  22: 300000,
  23: 300000,
  24: 300000,
  25: 300000,
  26: 300000,
  27: 300000,
  28: 300000,
  29: 300000,
  30: 300000,
  31: 300000,
  32: 300000,
  33: 300000,
  34: 300000,
  35: 300000,
  36: 300000,
};

export const costPerInstallMonths = {
  0: 2.5,
  1: 2.5,
  2: 2,
  3: 1.5,
  4: 1.25,
  5: 1,
  6: 1.5,
  7: 1.5,
  8: 1.5,
  9: 1.5,
  10: 1.5,
  11: 1.5,
  12: 1.5,
  13: 1.5,
  14: 1.5,
  15: 1.5,
  16: 1.5,
  17: 1.5,
  18: 1.5,
  19: 1.5,
  20: 1.5,
  21: 1.5,
  22: 1.5,
  23: 1.5,
  24: 1.5,
  25: 1.5,
  26: 1.5,
  27: 1.5,
  28: 1.5,
  29: 1.5,
  30: 1.5,
  31: 1.5,
  32: 1.5,
  33: 1.5,
  34: 1.5,
  35: 1.5,
  36: 1.5,
};

export const registrationMonths = {
  0: 50,
  1: 50,
  2: 50,
  3: 50,
  4: 50,
  5: 50,
  6: 50,
  7: 50,
  8: 50,
  9: 50,
  10: 50,
  11: 50,
  12: 50,
  13: 50,
  14: 50,
  15: 50,
  16: 50,
  17: 50,
  18: 50,
  19: 50,
  20: 50,
  21: 50,
  22: 50,
  23: 50,
  24: 50,
  25: 50,
  26: 50,
  27: 50,
  28: 50,
  29: 50,
  30: 50,
  31: 50,
  32: 50,
  33: 50,
  34: 50,
  35: 50,
  36: 50,
};

export const subscriptionMonths = {
  0: 3.5,
  1: 3.5,
  2: 3.5,
  3: 3.5,
  4: 3.5,
  5: 3.5,
  6: 3.5,
  7: 3.5,
  8: 3.5,
  9: 3.5,
  10: 3.5,
  11: 3.5,
  12: 3.5,
  13: 3.5,
  14: 3.5,
  15: 3.5,
  16: 3.5,
  17: 3.5,
  18: 3.5,
  19: 3.5,
  20: 3.5,
  21: 3.5,
  22: 3.5,
  23: 3.5,
  24: 3.5,
  25: 3.5,
  26: 3.5,
  27: 3.5,
  28: 3.5,
  29: 3.5,
  30: 3.5,
  31: 3.5,
  32: 3.5,
  33: 3.5,
  34: 3.5,
  35: 3.5,
  36: 3.5,
};

export const churnRateMonths = {
  0: 55,
  1: 55,
  2: 55,
  3: 55,
  4: 55,
  5: 55,
  6: 55,
  7: 55,
  8: 55,
  9: 55,
  10: 55,
  11: 55,
  12: 55,
  13: 55,
  14: 55,
  15: 55,
  16: 55,
  17: 55,
  18: 55,
  19: 55,
  20: 55,
  21: 55,
  22: 55,
  23: 55,
  24: 55,
  25: 55,
  26: 55,
  27: 55,
  28: 55,
  29: 55,
  30: 55,
  31: 55,
  32: 55,
  33: 55,
  34: 55,
  35: 55,
  36: 55,
};

// netWorkingCapitalAssumptionsReducer

export const nwcMonths = {
  1: 1,
  2: -2,
  3: 3,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
  10: 1,
  11: 1,
  12: 1,
  13: 1,
  14: 1,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 1,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 1,
  28: 1,
  29: 1,
  30: 1,
  31: 1,
  32: 1,
  33: 1,
  34: 1,
  35: 1,
  36: 1,
};

// capexAssumptionsReducer
export const capexMonths = {
  1: 1,
  2: 3,
  3: 4,
  4: 5,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

// defaultZeroMonths
export const defaultZeroMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};
